<div
  class="yCmsContentSlot account-section-content reports-page"
  *ngIf="dashboard !== true"
>
  <div class="row row-20">
    <div class="col-md-5 col-sm-6 col-xs-12">
      <h1 class="prodCat-title">Reports</h1>
    </div>
  </div>
  <div class="row row-20" id="leftCont-rightNav">
    <div class="col-md-12 col-lg-8 border-right">
      <div class="left-section-wrapper row">
        <div class="col-md-12 p0 reportBannerSlt">
          <img *ngIf='baseSiteId === "vsh"' title="" alt="" src="../../../assets/img/reports-page-img.png" />
          <img *ngIf='baseSiteId === "vax"' title="" alt="" src="../../../assets/img/report-vax.png" />
        </div>
        <div class="col-md-12 p0">
          <div class="need-for-reports">
            <div class="content">
              <h4 class="ff-bold m0 fs-14">
                Understand your business needs using
              </h4>
              <h1 class="main-heading" *ngIf='baseSiteId === "vsh"'>
                VaccineShop Reports
              </h1>
              <h1 class="main-heading" *ngIf='baseSiteId === "vax"'>
                VaxServe Reports
              </h1>
              <p class="fs-14">
                Now you can get insights on your purchasing insights, discounts,
                and savings to help you adjust to your business needs.
              </p>
              <p class="access-reports fs-14">Access a range of reports:</p>
            </div>
            <div class="content" *ngIf="isLoggedInUser === true">
              <ul class="multiple-links">
                <ng-container
                  *ngFor="let reports of reportsList; let i = index"
                >
                  <li
                    [ngClass]="{ hideDiv: reports.description === undefined }"
                  >
                    <p class="ff-bold light-color fs-14 m0">
                      {{ reports.description }}
                    </p>
                    <button
                      class="launch-report btn-primary"
                      (click)="getreportDetails(reports.reportId)"
                    >
                      Launch report
                    </button>
                  </li>
                </ng-container>
              </ul>
            </div>

            <div class="content" *ngIf="isLoggedInUser === false">
              <ul class="single-layout">
                <ng-container *ngFor="let type of typesOfReoprts">
                  <li
                  [ngStyle]="{
                    'background-image':
                      'url(../../../assets/icons/' +
                      baseSiteId +
                      '/checkmark.svg)'
                  }" class="ff-bold fs-14"
                >
                  {{ type }}
                </li>
              </ng-container>
                <button
                  class="
                    ad-blue-button
                    login-btn
                    access-reports-btn
                    btn-primary
                  "
                  (click)="navigateToLogInPage()"
                >
                  Log in to access reports
                </button>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-lg-4">
      <!-- <div class="right-section-wrapper">
        <img *ngIf='baseSiteId === "vsh"' 
          title="horizantal banner"
          alt="horizantal banner"
          src="assets/img/horizontal_300.gif"
        />
      </div> -->
    </div>
  </div>
</div>
<div class="content else-case" *ngIf="dashboard === true">
  <div class="row acc-chart">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 sanofi-chart-text">
      <h3>Reports</h3>
      <p class="chart-acc">
        Now you can get insights on your purchasing insights, discounts, and
        savings to help you adjust to your business needs.
      </p>
      <div class="row">
        <div class="col-md-12 ac-report">
          <p>Access a range of reports:</p>
          <ul>
            <ng-container *ngFor="let type of typesOfReoprts">
              <li
                [ngStyle]="{
                  'background-image':
                    'url(../../../assets/icons/' +
                    baseSiteId +
                    '/checkmark.svg)'
                }"
              >
                {{ type }}
              </li>
            </ng-container>
          </ul>
          <div class="launchMyDashboard">
            <button type="button" (click)="goToReports()" class="btn-primary">
              Launch my dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-6">
      <div class="ct-donut-wrapper">
        <br /><img *ngIf='baseSiteId === "vsh"' src="../../../assets/img/reports-page-img.png" alt="" />
        <img *ngIf='baseSiteId === "vax"' title="" alt="" src="../../../assets/img/report-vax.png" />
      </div>
    </div>
  </div>
</div>